<template>
  <div class="container-fluid vehicle-index-page">
    <div class="vehicle-index-container">
      <div class="listing-page">
        <div class="row">
          <div class="col-lg-12">
            <div id="srp-title" class="vehicles-found-container">
              <h1><span class="srp-title">Vehicles in City, US</span></h1>
              <div>
                <span class="vehicles-found"
                  >{{ selectedBrandVehicles.length || '' }} vehicles available for sale</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row vehicle-sort-menu" role="complementary">
          <div class="col-md-3 col-md-offset-9 col-xs-12">
            <div class="text-center">
              <div class="btn-group" role="group">
                <button
                  id="mobile-refine-results"
                  class="btn btn-default visible-sm visible-xs"
                  aria-controls="sticky-menu-container"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  Refine Results
                </button>
                <div class="btn-group">
                  <button
                    id="sortResultsDropdown"
                    class="btn btn-default dropdown-toggle"
                    aria-expanded="false"
                    aria-controls="sort-results"
                    aria-haspopup="listbox"
                    data-toggle="dropdown"
                    type="button"
                  >
                    Sort Results <span class="caret"></span>
                  </button>
                  <ul
                    id="sort-results"
                    class="dropdown-menu"
                    aria-labelledby="sortResultsDropdown"
                    role="listbox"
                  >
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Discount: Highest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Price: Lowest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Price: Highest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Mileage: Lowest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Year: Newest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Year: Oldest First</span>
                      </a>
                    </li>
                  </ul>
                  <button class="btn btn-default" id="toggle-model-search">
                    <i class="fa fa-car"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <SideFilerMenu :headerColor="brandColors['--primary-color']" :brand="brand"/>
          <div
            class="col-lg-10 col-md-9 col-sm-12"
            id="vehicles"
            role="main"
            aria-labelledby="srp-title"
            tabindex="-1"
          >
            <RowVehicle
              v-for="vehicle in selectedBrandVehicles"
              :key="`vehicle-${vehicle.modelName}`"
              v-bind="{
                vehicle,
                price: getRandomPrice(),
                priceBtnTitle: priceBtn.title,
                isLockedPricingSelected,
                selectedPriceBtn,
                brandColors,
                brand
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SideFilerMenu from "./srp-child-components/SideFilterMenu.vue";
import RowVehicle from "./srp-child-components/RowVehicle.vue";

export default {
  name: "row-based-search-results",
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      prices: [
        {
          market: 39488,
          belowMarket: 36284,
        },
        {
          market: 49583,
          belowMarket: 44413,
        },
        {
          market: 27995,
          belowMarket: 24089,
        },
        {
          market: 36999,
          belowMarket: 32494,
        },
      ],
    }
  },
  computed: {
    ...mapState(['chosenBrand', 'chosenComponents', 'buttonComponents']),
    ...mapGetters(['brandData', 'selectedBrandVehicles']),
    isLockedPricingSelected() {
      return !!this.chosenComponents.find(c => c.title === 'Locked Pricing')
    },
    priceBtn() {
      let component = this.chosenComponents.find(c => c.type === 'get-price-btn')
      if (!component) {
        component = this.findDefaultButton()
      }
      return component
    },
    selectedPriceBtn() {
      const brandBtn = this.priceBtn.previews.find((p) =>  {
        for (var i = 0; i < p.brands.length; i++) {
          if (p.brands[i].toLowerCase() === this.brand.toLowerCase()) {
            return p
          }
        }
      })
      if (brandBtn) {
        return brandBtn
      }
      return this.priceBtn.previews.find(c => c.primary)
    },
    brandColors() {
      return this.brandData.colors
    }
  },
  methods: {
    getRandomPrice() {
      return this.prices[Math.floor(Math.random() * this.prices.length)];
    },
    findDefaultButton() {
      if (this.isLockedPricingSelected) {
        return this.buttonComponents.lockedPricing.find(c => c.type === 'get-price-btn')
      }
      return this.buttonComponents.unlockedPricing.find(c => c.type === 'get-price-btn')
    }
  },
  components: {
    RowVehicle,
    SideFilerMenu,
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.vehicle-sort-menu {
  height: 55px;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 10px;
  background: #333333;
  color: #fff;
}
.vehicle-sort-menu .vehicles-found {
  font-size: 15px;
  font-weight: 300;
  padding-top: 20px;
}
.vehicle-sort-menu #sortResultsDropdown:focus {
  outline: 1px solid red;
}

.flexslider-interval-srp-banners {
  width: 100%;
}

@media (max-width: 400px) {
  .vehicle-sort-menu .vehicles-found {
    padding-top: 0;
  }
}

.vehicle-inventory-tile {
  margin-bottom: 8px;
  padding: 0 5px !important;
}
.vehicle-inventory-tile h3 {
  font-size: 16px;
  text-align: center;
}
.vehicle-inventory-tile .tile-contents {
  background: #f5f5f5;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  padding: 0 10px;
  min-height: 650px;
}
.vehicle-inventory-tile .tile-contents {
  width: 100%;
}
.vehicle-inventory-tile .vehicle-thumb-tile {
  padding-top: 5px;
}
.vehicle-inventory-tile .vehicle-thumb-tile img {
  max-width: 100%;
  height: 145px;
  margin: 0 auto;
}
.vehicle-inventory-tile .vehicle-index-summary {
  font-size: 13px;
  margin: 0 auto;
  max-width: 400px;
}
.vehicle-inventory-tile .vehicle-info-summary {
  padding: 0 3px 0 3px;
}
.vehicle-inventory-tile .tile-specials .special-title {
  font-size: 14px;
  margin-top: 5px;
}
.vehicle-inventory-tile .tile-index-buttons {
  position: absolute;
  bottom: 5px;
}
.vehicle-inventory-tile .tile-index-buttons .btn {
  border-radius: 0 !important;
}
.vehicle-inventory-tile .tile-index-buttons .eprice-button {
  margin-top: 0;
}
.vehicle-inventory-tile .tile-index-buttons .price-alert-button {
  padding: 10px;
  background-image: none !important;
  font-weight: bold;
  font-family: var(--bold-text);
}

.vehicle-unit {
  background: #fff;
  padding: 5px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
}

.vehicle-index-price.vehicle-price-block {
  border: none;
}
.vehicle-index-price.vehicle-price-block h5 {
  font-size: 12px;
  margin: 0 0 10px;
}
.vehicle-index-price.vehicle-price-block h3,
.vehicle-index-price.vehicle-price-block h4 {
  margin: 0 0 5px;
}
.vehicle-index-price.vehicle-price-block .price-savings {
  text-align: center;
}

#panorama {
  min-height: 500px;
}

.pnlm-container {
  background: #777;
}

.srp-pano-view-link {
  bottom: 8px;
  position: absolute;
  opacity: 0.8;
  left: calc(50% - 40px);
  cursor: pointer;
  color: #fff;
  background: #000;
  z-index: 100;
  border: 2px solid #000;
  font-weight: 500;
  font-family: var(--bold-text);
  font-size: 12px;
  padding: 3px 6px;
  width: 88px;
  border-radius: 20px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.srp-window-sticker-link i {
  font-size: 20px;
  color: green;
}

.srp-window-sticker-link span {
  font-weight: 400;
}

.accordion-col .vehicle-certification-badge {
  max-width: 100%;
  margin: 15px auto 0;
}

div:not(.accordion-col) .vehicle-certification-badge {
  margin-bottom: 3px;
  margin-top: 8px;
  margin-right: 8px;
  height: 55px;
  cursor: pointer;
}

.vehicle-price-certificate img {
  margin-bottom: 3px;
  margin-top: 8px;
  margin-right: 8px;
  height: 70px;
  cursor: pointer;
}

.srp-mmd {
  display: block;
  margin: 20px auto;
  width: 100px;
}
.srp-mmd .payment-tag {
  padding-top: 28% !important;
}

.pure-cars-badge {
  margin-bottom: 3px;
  margin-top: 8px;
  margin-right: 8px;
  cursor: pointer;
}

.drive-it-now-badge {
  margin: 7px 0;
}

.pure-cars-vdp {
  padding-top: 5px;
  max-width: 100%;
}

.vehicle-badges > * {
  vertical-align: middle;
}

.car-code-sms-button {
  width: 80px;
  font-size: 16px;
  background-color: red;
  border-radius: 0;
  color: #fff;
  font-weight: bold;
  font-family: var(--bold-text);
  margin: 8px;
  border-radius: 5px !important;
  display: inline-block;
  vertical-align: middle;
}

.vehicle-index-summary {
  padding-bottom: 10px;
  padding-top: 10px;
}

.vehicle-index-page {
  padding: 30px;
  width: 100%;
  background: #fff;
  font-family: var(--body-text);
}

.vehicle-index-page h1 {
  font-family: var(--heading-text);
}
.vehicle-index-page h2, .vehicle-index-page h3, .vehicle-index-page h4, .vehicle-index-page h5, .vehicle-index-page h6 {
  font-family: var(--subheading-text);
}

.vehicle-index-container {
  max-width: 1440px;
  margin: auto;
  background: #fff;
}

.listing-page {
  padding-top: 15px;
  margin: 0 auto;
}

.filter-form {
  margin-top: 5px;
}

.listing-page .filter-list {
  padding: 0px;
  margin: 0px;
  background: #fff;
}

.listing-page .filter-list li:last-child {
  border-bottom: none;
}

.listing-page .filter-list li span {
  color: #16377c !important;
  font-weight: bold;
  font-family: var(--bold-text);
}

.listing-page .filter-list li a {
  color: #333;
}

.page-filter {
  padding-top: 10px;
  padding-bottom: 5px;
}

.page-filter .headings {
  color: #333333;
  font-size: 24px;
  padding: 0px;
  padding-right: 20px;
}

.page-filter span {
  font-size: 15px;
  color: #333333;
  padding-right: 2px;
}

.page-filter a {
  color: #333;
}

.page-filter span:last-child {
  padding: 0px;
}

.page-filter .glyphicon {
  font-size: 24px;
}

.blue {
  color: #16377c !important;
}

.search-list.car-srch-box {
  min-height: 207px;
}

.car-srch-box h2 {
  color: #002571;
  font-size: 18px;
  margin: 0px;
  font-weight: 400;
}

.vdp-link {
  font-weight: 300;
  font-size: 14px;
  color: #5b616b;
}

.search-list {
  margin-bottom: 2px;
  margin-top: 10px;
}

.search-list .car-srch-box .spects {
  padding-top: 15px;
  padding-bottom: 15px;
}

.vehicle-thumb img {
  width: 100%;
}

.vehicle-index-summary .pull-right {
  font-weight: 300;
}

.HomeContentRight h3 {
  color: darkblue;
  background: white;
  padding: 15px auto;
  border-radius: 4px;
  border-color: #ccc;
}

.stacked-srp-prices h3,
.stacked-srp-prices h4 {
  margin: 0 0 5px;
}

.stacked-srp-prices h5 {
  margin: 0 0 10px;
  font-size: 12px;
}

.stacked-srp-prices .vauto-incentives h4 {
  font-size: 16px;
}

.stacked-srp-prices .single-stacked-price {
  margin-top: 37px;
}

.stacked-srp-prices .double-stacked-price {
  margin-top: 15px;
}

.stacked-srp-prices .price-savings {
  color: green;
}
.stacked-srp-prices .price-savings h5 {
  padding-bottom: 5px;
  border-bottom: 1px solid;
}

.stacked-srp-prices .price-total-savings {
  color: green;
}
.stacked-srp-prices .price-total-savings h4 {
  font-size: 1.7em;
}
.stacked-srp-prices .price-total-savings h5 {
  padding-bottom: 5px;
  border-bottom: none;
}

.vehicle-specs {
  font-size: 14px;
  font-weight: bold;
  font-family: var(--bold-text);
}
.vehicle-specs h2 {
  font-size: 20px;
  padding-bottom: 10px;
}

.sticky-bottom-content {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  padding: 10px;
  z-index: 99;
  border-top: 1px solid black;
}

.text-toggle {
  display: inline-block;
  background-color: #a5a5a5;
  color: white;
  padding: 3px 5px;
  border-radius: 5px;
}
.text-toggle:hover {
  cursor: pointer;
}

@media only screen and (min-width: 768px) {
  .vehicle-index-price {
    padding-top: 90px;
  }
  .index-button-padding {
    padding: 0;
  }
}

@media only screen and (max-width: 768px) {
  .vehicle-unit {
    padding-bottom: 10px;
  }
  .car-srch-box {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .spects .bottom_link a {
    padding: 10px;
    font-size: 14px;
  }
  .page-filter .glyphicon-th-list {
    margin-right: 10px;
  }
  .filter-form {
    padding-right: 0;
  }
}

@media only screen and (max-width: 768px) {
  .index-button-left {
    padding-right: 0;
  }
  .index-button-right {
    padding-left: 0;
  }
  .search-list .vehicle-index-price {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .search-list .vehicle-index-price h3 {
    font-size: 15px;
  }
  .right-button-cont {
    padding: 25px 0 0 0;
  }
  .filter-form {
    padding-right: 0;
  }
  .spects .bottom_link a {
    margin-bottom: 10px;
  }
  .small_p {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .col-sm-4.car-box {
    margin-bottom: 20px;
    background: #fff;
  }
  .filter-form {
    padding-right: 0;
  }
  .Banner .item img {
    min-height: auto !important;
  }
  .FooterBlack .left_footer_text {
    text-align: center;
    width: 100%;
    display: inline-block;
  }
  .FeaturedCarData {
    text-align: center;
  }
}

@media only screen and (max-width: 1024px) {
  .available-rebates-btn {
    font-size: 12px;
  }
}

.filter-select-btn {
  white-space: normal;
  border: none;
}

.listing-page {
  min-height: 400px;
}
.listing-page .filter-list li {
  padding: 10px 10px;
  border-bottom: 1px solid #e5e5e5;
  color: #333333;
  list-style: none;
  text-align: center;
}

.vehicles-found-container h1 {
  font-size: 18px;
  margin: 0;
}

.vehicles-found-container div {
  font-size: 15px;
  margin: 0;
}

.sort-menu {
  left: 20px;
}

.search-query-span {
  float: right;
  font-weight: bold;
  font-family: var(--bold-text);
  font-size: 1.4em;
  padding-bottom: 10px;
}

.mobile-filter-section .btn {
  border-radius: 0;
}

.vehicle-filter-menu {
  max-height: 90%;
  overflow: hidden;
  width: inherit !important;
}
.vehicle-filter-menu .section-divider {
  border-bottom: 1px #ccc solid;
  min-height: 1px;
  clear: both;
  width: 100%;
  height: 1px;
}
.vehicle-filter-menu a.section-heading {
  display: block;
  color: #333333;
  font-size: 17px;
  padding: 2px 0 0 10px;
  margin: 4px 0 4px 0;
}
.vehicle-filter-menu a.section-heading:hover,
.vehicle-filter-menu a.section-heading:active,
.vehicle-filter-menu a.section-heading:visited,
.vehicle-filter-menu a.section-heading:focus {
  text-decoration: none;
}
.vehicle-filter-menu a.section-heading .selected-icon {
  float: right;
  padding-right: 10px;
  color: #333333;
}
.vehicle-filter-menu:hover,
.vehicle-filter-menu:active,
.vehicle-filter-menu:visited,
.vehicle-filter-menu:focus {
  text-decoration: none;
}
.vehicle-filter-menu .section-color,
.vehicle-filter-menu .section-interior_color {
  text-transform: capitalize;
}
.vehicle-filter-menu .filter-section-mileage .filter-list,
.vehicle-filter-menu .filter-section-price .filter-list {
  padding-left: 18px;
  padding-right: 18px;
}
.vehicle-filter-menu .filter-section-mileage .filter-list .irs,
.vehicle-filter-menu .filter-section-price .filter-list .irs {
  padding: 0;
}
.vehicle-filter-menu .filter-list {
  max-height: 120px;
  min-height: 390px;
  overflow: scroll;
  overflow-x: hidden;
  background: #f5f5f5;
}
.vehicle-filter-menu .filter-list .irs {
  padding: 2px 18px 0 0;
}
.vehicle-filter-menu .filter-list label {
  display: block;
  padding: 3px 0 0 20px;
  font-weight: 400;
}
.vehicle-filter-menu .filter-list input {
  margin-right: 8px;
}

@media (min-width: 992px) {
  .vehicles-found-container h1 {
    font-size: 20px;
  }
  .vehicles-found-container div {
    font-size: 18px;
  }
  .sticky-side-menus {
    width: 200px;
  }
  .vehicle-filter-menu,
  .vehicle-search-menu {
    margin-top: 10px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  }
  .vehicle-filter-menu .sort-menu,
  .vehicle-search-menu .sort-menu {
    top: 95%;
  }
  .vehicle-filter-menu .no-padding,
  .vehicle-search-menu .no-padding {
    padding: 0;
  }
  .vehicle-filter-menu .panel,
  .vehicle-search-menu .panel {
    border-radius: 0;
    margin-bottom: 0;
  }
  .vehicle-filter-menu .panel .panel-heading,
  .vehicle-search-menu .panel .panel-heading {
    border-radius: 0;
    font-size: 16px;
    color: #ffffff;
    background-color: red;
    background-image: none;
  }
  .vehicle-filter-menu .panel .panel-body,
  .vehicle-search-menu .panel .panel-body {
    padding: 0 10px 50px;
  }
  .vehicle-filter-menu .panel .panel-footer,
  .vehicle-search-menu .panel .panel-footer {
    padding: 0 15px;
  }
  .vehicle-filter-menu .panel .btn,
  .vehicle-search-menu .panel .btn {
    border-radius: 0;
  }
}

.sort-menu-container {
  overflow-y: auto;
  position: relative;
}
.sort-menu-container .filter-selected {
  width: 80%;
  float: left;
}
.sort-menu-container .remove-filter {
  margin-top: 4px;
  cursor: pointer;
}
</style>